import { FilterConfig } from "../../models/FilterConfig";
import { LineofBusiness } from "../../models/LineofBusinessFilterData";

export const CostToServeFilterConfig: Record<LineofBusiness, FilterConfig[]> = {
  electrical: [
    {
      apiKey: "district",
      filterLabelKey: "District",
      filterValueKey: "District",
      filterName: "District",
      type: "multi",
      payloadValuekey: "district",
    },
  ],
  plumbing: [
    {
      apiKey: "pc",
      filterLabelKey: "pc",
      filterValueKey: "pc",
      filterName: "PCs",
      type: "single",
      payloadValuekey: "pc",
    },
  ],
};

export const filterDefaultValues: Record<LineofBusiness, any> = {
  electrical: {
    district: ["All"],
  },
  plumbing: {},
};
